<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSpeakerDisabled_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M2.037 1.636a.5.5 0 0 1 .707 0l12.408 12.411a.5.5 0 0 1-.707.707l-1.02-1.021a7.151 7.151 0 0 1-.637.524.599.599 0 1 1-.702-.972 3.05 3.05 0 0 0 .324-.283c.048-.047.096-.093.146-.138l-1.473-1.473a4.25 4.25 0 0 1-.929.616.6.6 0 0 1-.509-1.087c.216-.101.409-.233.592-.376L7.5 7.807v5.526a.666.666 0 0 1-1.2.4l-2.27-3.028-2.19-.438A1.667 1.667 0 0 1 .5 8.633V7.366c0-.794.561-1.478 1.34-1.634l2.189-.438.411-.548-2.403-2.403a.5.5 0 0 1 0-.707ZM14.8 8c0 1.19-.34 2.339-.94 3.338l.874.874A7.702 7.702 0 0 0 16 8a7.75 7.75 0 0 0-3.21-6.257.599.599 0 1 0-.702.972A6.542 6.542 0 0 1 14.8 8ZM6.833 2c.369 0 .667.298.667.667v2.311L5.652 3.13l.648-.863A.666.666 0 0 1 6.833 2Zm4.681 6a3.245 3.245 0 0 0-1.869-2.92.6.6 0 0 1 .509-1.087A4.448 4.448 0 0 1 12.714 8c0 .631-.139 1.243-.391 1.802l-.933-.933c.08-.28.124-.571.124-.869Z"
        clip-rule="evenodd"
    />
</svg>
